/**
 * @generated SignedSource<<2f2fa9fc2656fb3562286dfc9dad44e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HistoryCharts_history$data = {
  readonly id: string;
  readonly status: string;
  readonly earningTotal: {
    readonly cents: number;
    readonly formatted: string;
  } | null;
  readonly cashoutTotal: {
    readonly formatted: string;
  } | null;
  readonly earningBreakdown: ReadonlyArray<{
    readonly type: string;
    readonly label: string;
    readonly amount: {
      readonly cents: number;
      readonly currency: string;
      readonly formatted: string;
    };
  }> | null;
  readonly cashoutBreakdown: ReadonlyArray<{
    readonly type: string;
    readonly label: string;
    readonly amount: {
      readonly cents: number;
      readonly currency: string;
      readonly formatted: string;
    };
  }> | null;
  readonly monthlyEarnings: ReadonlyArray<{
    readonly date: string;
    readonly type: string;
    readonly amount: {
      readonly cents: number;
      readonly currency: string;
      readonly formatted: string;
    };
  }> | null;
  readonly " $fragmentType": "HistoryCharts_history";
};
export type HistoryCharts_history$key = {
  readonly " $data"?: HistoryCharts_history$data;
  readonly " $fragmentSpreads": FragmentRefs<"HistoryCharts_history">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cents",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./HistoryRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "HistoryCharts_history",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "earningTotal",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "cashoutTotal",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HistoryTotalAmount",
      "kind": "LinkedField",
      "name": "earningBreakdown",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HistoryTotalAmount",
      "kind": "LinkedField",
      "name": "cashoutBreakdown",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HistoryMonthlyAmount",
      "kind": "LinkedField",
      "name": "monthlyEarnings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "History",
  "abstractKey": null
};
})();

(node as any).hash = "e152ee58d93ea3ded6a8788580477103";

export default node;
